import React, { useEffect, useMemo, useState } from 'react';
import { Button, Card, Flex, Form, Slider, Select, Modal, Upload, Tabs, Space, Input, DatePicker, Divider, Col, Row } from 'antd';
import PageHeader from '../../view/pageheader';
import { DownloadOutlined, PlusOutlined, SaveOutlined, UploadOutlined, PrinterOutlined, ReloadOutlined, ScanOutlined, SearchOutlined } from '@ant-design/icons';
import { updateWeareHouseData, weareHouseById, updateWareHousestatus, completedweareHouseById, uploadWeareHouseData, clearWareHouseyIdData, clearCompletedWareHouseByIdData } from "../../store/reducer/wearehouseSlice";
import { getJobsList } from "../../store/reducer/jobSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { toast } from 'react-toastify'
import { FileAllType } from '../../store/reducer/prepQueueSlice';
import TableComponent from '../CustomComponents/TableComponent';
import { getCustomerList } from "../../store/reducer/customerSlice";
import moment from "moment-timezone";
import Loader from '../../fields/Loader/Loader';
import SearchComponent from '../CustomComponents/SearchComponent';
import dayjs from 'dayjs';
import TextArea from 'antd/es/input/TextArea';
import { set } from 'react-hook-form';
const { TabPane } = Tabs;
const AddWareHouse = () => {
    const { id } = useParams();
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const getQueryParams = () => {
        const params = new URLSearchParams(location.search);
        return {
            query: params.get("query") || "",
        };
    };
    const [preprocessingQueueData, setPreprocessingQueueData] = useState([]);
    const [completedPreprocessingQueueData, setCompletedPreprocessingQueueData] = useState([]);
    const [completedOrginalData, setCompletedOrginalData] = useState([]);
    const [customerList, setCustomerList] = useState([]);
    const [jobData, setJobData] = useState([]);
    const [originalData, setOriginalData] = useState([]);
    const { weareHouseByIdData, completedWeareHouseByIdData } = useSelector((state) => state.wearehouse);
    const { customerListData } = useSelector((state) => state.customers);
    const { AllFileData } = useSelector((state) => state.prepTeamQueue);
    const { jobListData } = useSelector((state) => state.jobs);
    const userId = localStorage.getItem('user_id');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [uploadModalVisible, setUploadModalVisible] = useState(false);
    const [modifiedRows, setModifiedRows] = useState(new Set());
    const [fileData, setFileData] = useState([])
    const [activetab, setActiveTab] = useState("1")
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [barocdestartvalue, setBarocdestartvalue] = useState('');
    const [barocdeendvalue, setBarocdeendvalue] = useState('');
    const [uniqueIdStartValue, setUniqueIdStartValue] = useState('');
    const [uniqueIdEndValue, setUniqueIdEndValue] = useState('');
    const [pendingPayload, setPendingPayload] = useState(null);
    const [searchModal, setSearchModal] = useState(false)
    const [clearData, setClearData] = useState(false);

    function getAllData(payload = {}) {
        dispatch(getJobsList(payload))
        dispatch(FileAllType(payload))
        dispatch(getCustomerList(payload))

    }
    function getData(payload = {}) {
        const query = payload.query || '';
        if (id) {
            getAllData()
            const editId = window.atob(id);
            const assign_user_id = localStorage.getItem('user_id');
            //   dispatch(clearCompletedBox());
            //   dispatch(clearnotCompletedBox());
            if (activetab == '1') {

                dispatch(weareHouseById({ editId, query, ...payload }));

            }
            else if (activetab == '2') {
                dispatch(completedweareHouseById({ editId, query, assign_user_id, payload }));
            }

        }

    }
    useEffect(() => {
        if (id && activetab && pendingPayload !== null) {
            getData(pendingPayload);
        }
    }, [id, activetab, pendingPayload]);
    useEffect(() => {
        const { query } = getQueryParams();

        const payload = {};
        if (query && query.trim() !== "") {
            setSearchText(query.trim());
            payload.query = query.trim();
        }

        // if (pickup_date) {
        //     setSearchDate(pickup_date); // keep as string if backend expects MM/DD/YYYY
        //     payload.pickup_date = pickup_date;
        // }

        if (payload.query) {
            setPendingPayload(payload);
            setActiveTab("2");
        } else {
            setPendingPayload({});
            setActiveTab(id === "all" ? "2" : "1");
        }
    }, [id, location.search]);
    useEffect(() => {
        let formattedData1 = [];
        if (activetab == '1' && Array.isArray(weareHouseByIdData?.data)) {

            formattedData1 = weareHouseByIdData?.data.map((item, index) => ({
                ...item,
                key: index.toString(),
            }));
        }

        if (formattedData1.length > 0) {
            setPreprocessingQueueData(formattedData1);
            setOriginalData(JSON.stringify(formattedData1));
        }
    }, [weareHouseByIdData, activetab]);

    useEffect(() => {
        let formattedData2 = [];
        if (activetab == '2' && Array.isArray(completedWeareHouseByIdData?.data)) {
            formattedData2 = completedWeareHouseByIdData?.data.map((item, index) => ({
                ...item,
                key: index.toString(),
            }));
        }
        if (formattedData2.length > 0) {
            setCompletedPreprocessingQueueData(formattedData2);
            setCompletedOrginalData(JSON.stringify(formattedData2));
        }
    }, [completedWeareHouseByIdData, activetab]);
    const specIdData = useMemo(() => {
        if (!preprocessingQueueData.length || !jobData.length) return [];
        return jobData
            .map((item) => ({
                label: item?.spec_id,
                value: item?.id,
                workflow_id: item?.workflow_id,
                customer_id: item?.customer_id,
                customer_name: item?.customer?.customername
            }));
    }, [jobData, preprocessingQueueData]);

    const customerLists = useMemo(() => {
        if (!jobData.length || !customerList.length) return [];
        const jobCustomerIds = new Set(jobData.map((job) => job.customer_id));
        return customerList.filter((customer) => customer.status === 1 && jobCustomerIds.has(customer.id)).map((item) => ({
            label: item.customername,
            value: item.id
        }));
    }, [customerList])
    const fileDatas = useMemo(() => {

        return fileData
            .map((item) => ({
                label: item?.file_type,
                value: item?.id,

            }));
    }, [fileData]);
    const handleSearch = () => {
        const payloadData = {
            query: searchText,
        };



        getData(payloadData);

        setSearchText('');

    };
    const handleDownloadExcel = () => {

        const tableData = preprocessingQueueData.map(
            ({
                box_unique_id, spec, box, alt_box, barcode, from, to, printed_name, date_in, description, series_box, loc, building, aisle, level, shelf, customer_name,
            }) => ({
                'Unique ID': box_unique_id,
                'Customer Name': customer_name,
                'Spec ID': spec,
                'Box': box,
                'Alt Box': alt_box,
                'Scantek Barcode': barcode,
                'From': from,
                'To': to,
                'Label Printed Name/Date': printed_name,
                'Date In (mm/dd/yyyy)': date_in ? moment(date_in).format("MM/DD/YYYY") : null,
                'Description': description,
                'Series Box': series_box,
                'Loc': loc,
                'Building or Address': building,
                'Aisle': aisle,
                'Level': level,
                'Shelf': shelf,

            })
        );

        // Create headers
        const combinedSheetData = [['Allowed Spec Id', 'All File Types']];

        // Get max length to iterate safely
        const maxLength = Math.max(specIdData.length, fileDatas.length, customerLists.length);

        const customerMap = {};
        customerList.forEach(customer => {
            customerMap[customer.id] = customer.customername;
        });
        const ws1 = XLSX.utils.json_to_sheet(tableData);
        const ws2 = XLSX.utils.aoa_to_sheet(combinedSheetData);
        const colWidth1 = 25;
        ws1['!cols'] = Object.keys(tableData[0] || {}).map(() => ({ wch: colWidth1 }));
        const colWidth2 = 30;
        ws2['!cols'] = combinedSheetData[0].map(() => ({ wch: colWidth2 }));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws1, 'Preprocessing Queue');
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(data, 'WareHouse.xlsx');
    };

    const handleDownloadBarcodeExcel = () => {


        if (selectedRowKeys.length == 0) {
            toast.error("Please select at least one row to download the barcode Excel file.");
            return;
        }
        const tableData = selectedRowKeys.map(
            ({
                box_unique_id, spec, box, alt_box, barcode, from, to, printed_name, date_in, description, series_box, loc, building, aisle, level, shelf, left_warehouse,
            }) => ({

                'Spec ID': spec,
                'Box': box,
                'Alt Box': alt_box,
                'Scantek Barcode': barcode,
                'From': from,
                'To': to,
                'Description': description,


                // 'Left Warehouse (mm/dd/yyyy)': left_warehouse ? moment(left_warehouse).format("MM/DD/YYYY") : null,



                // 'Address': address,
                // 'Aisle': aisle,
                // 'Level': level,
                // 'Bay': bay,
                // 'From': from,
                // Important: Use JS Date objects so Excel recognizes them as dates
                // 'Pickup Date (mm/dd/yyyy)': pickup_date ? moment(pickup_date).format("MM/DD/YYYY") : null,
                // 'Left Warehouse (mm/dd/yyyy)': left_warehouse ? moment(left_warehouse).format("MM/DD/YYYY") : null,
            })
        );

        // Create headers
        const combinedSheetData = [['Allowed Spec Id', 'All File Types']];

        // Get max length to iterate safely
        const maxLength = Math.max(specIdData.length, fileDatas.length, customerLists.length);

        const customerMap = {};
        customerList.forEach(customer => {
            customerMap[customer.id] = customer.customername;
        });

        // Generate the combined data
        for (let i = 0; i < maxLength; i++) {
            const specId = specIdData[i]?.label ?? '';
            const customerId = specIdData[i]?.customer_name ?? '';
            const fileType = fileDatas[i]?.label ?? '';

            const customerName = customerMap[customerId] || '';
            const specWithCustomer = specId ? `${specId} - ${customerId}` : '';

            combinedSheetData.push([specWithCustomer, fileType || '']);
        }

        const ws1 = XLSX.utils.json_to_sheet(tableData);
        const ws2 = XLSX.utils.aoa_to_sheet(combinedSheetData);
        const colWidth1 = 25;
        ws1['!cols'] = Object.keys(tableData[0] || {}).map(() => ({ wch: colWidth1 }));
        const colWidth2 = 30;
        ws2['!cols'] = combinedSheetData[0].map(() => ({ wch: colWidth2 }));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws1, 'Preprocessing Queue');
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(data, 'scatek_barcode.xlsx');


        const postData = {
            updatedData: selectedRowKeys.map((data) => ({
                box_unique_id: data.box_unique_id,
                spec_id: data.job_id,
                is_printed: 1,
            })),
        };
        dispatch(updateWareHousestatus({ postData }))
            .then(() => {
                // On successful save, re-fetch the updated data
                const editId = atob(id);
                const assign_user_id = localStorage.getItem('user_id');
                window.location.reload();
                dispatch(weareHouseById({ editId, assign_user_id }))
                    .then(() => {
                        toast.success("Ware House Data Updated Successfully");
                        setModifiedRows(new Set());
                    });
            })
            .catch((error) => {
                toast.error("Please Select Spec ID ")
            });

    };
    const handleDownloadUniqueIDLabel = () => {


        if (selectedRowKeys.length == 0) {
            toast.error("Please select at least one row to download the barcode Excel file.");
            return;
        }
        const tableData = selectedRowKeys.map(
            ({
                box_unique_id
            }) => ({

                'Unique ID': box_unique_id,
            })
        );

        // Create headers
        const combinedSheetData = [['Allowed Spec Id', 'All File Types']];

        // Get max length to iterate safely
        const maxLength = Math.max(specIdData.length, fileDatas.length, customerLists.length);

        const customerMap = {};
        customerList.forEach(customer => {
            customerMap[customer.id] = customer.customername;
        });

        // Generate the combined data
        for (let i = 0; i < maxLength; i++) {
            const specId = specIdData[i]?.label ?? '';
            const customerId = specIdData[i]?.customer_name ?? '';
            const fileType = fileDatas[i]?.label ?? '';

            const customerName = customerMap[customerId] || '';
            const specWithCustomer = specId ? `${specId} - ${customerId}` : '';

            combinedSheetData.push([specWithCustomer, fileType || '']);
        }

        const ws1 = XLSX.utils.json_to_sheet(tableData);
        const ws2 = XLSX.utils.aoa_to_sheet(combinedSheetData);
        const colWidth1 = 25;
        ws1['!cols'] = Object.keys(tableData[0] || {}).map(() => ({ wch: colWidth1 }));
        const colWidth2 = 30;
        ws2['!cols'] = combinedSheetData[0].map(() => ({ wch: colWidth2 }));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws1, 'Unique ID Labels');
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(data, 'export_unique_id_label.xlsx');
        const postData = {
            updatedData: selectedRowKeys.map((data) => ({
                box_unique_id: data.box_unique_id,
                is_printed: 1,
            })),
        };
        dispatch(updateWareHousestatus({ postData }))
            .then(() => {
                // On successful save, re-fetch the updated data
                const editId = atob(id);
                const assign_user_id = localStorage.getItem('user_id');
                window.location.reload();
                dispatch(weareHouseById({ editId, assign_user_id }))
                    .then(() => {
                        toast.success("Ware House Data Updated Successfully");
                        setModifiedRows(new Set());
                    });
            })
            .catch((error) => {
                toast.error("Please Select Spec ID ")
            });

    };
    const excelDateToJSDate = (serial) => {
        const utc_days = Math.floor(serial - 25569);
        const utc_value = utc_days * 86400; // seconds in a day
        const date_info = new Date(utc_value * 1000); // convert to ms
        return moment(date_info).format("MM/DD/YYYY");
    };


    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        setFileList([]);
    };

    const handleUpload = async () => {


        const allowedExtensions = ["xlsx", "xls", "xlsm", "xltx", "ods", "xlsb"];
        if (!fileList.length) {
            toast.error("Please select an Excel file to upload!");
            return;
        }

        const file = fileList[0];


        const fileExtension = file.name.split(".").pop().toLowerCase();
        if (!allowedExtensions.includes(fileExtension)) {
            toast.error("Invalid file type! Please upload a valid Excel file.");
            return;
        }
        const reader = new FileReader();

        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });

            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json(sheet)
            // const allowedSpecIds = specIdData.map((item) => item.label);
            let hasErrors = false;
            // const allSpecIdsEmpty = jsonData.every(row => row["Spec ID"] === null || row["Spec ID"] === undefined);
            // if (allSpecIdsEmpty) {
            //   toast.error("All spec IDs is Empty");
            //   hasErrors = true;
            // }
            if (jsonData.length > preprocessingQueueData.length) {
                toast.error("You have uploaded more records than allowed!");
                hasErrors = true;
            }

            jsonData.forEach((row, index) => {
                if (!row["Unique ID"]) {
                    toast.error(`Row ${index + 1}: Missing required fields.`);
                    hasErrors = true;
                }
                if (row["Date In (mm/dd/yyyy)"] && typeof row["Date In (mm/dd/yyyy)"] == "number") {
                    row["Date In (mm/dd/yyyy)"] = excelDateToJSDate(row["Date In (mm/dd/yyyy)"]);
                }


            });

            jsonData.includes(jsonData)

            if (!hasErrors) {
                const specWorkflowMap = specIdData.reduce((map, item) => {
                    map[item.label] = item.workflow_id;
                    return map;
                }, {});

                // Add workflow_id to each row in jsonData
                const processedData = jsonData.map(row => ({
                    ...row,
                    workflow_id: row["Spec ID"] ? specWorkflowMap[row["Spec ID"]] : null
                }));
                const postData = {
                    jsonData: processedData,
                    assign_user_id: userId,
                    prep_queue_id: atob(id),
                    updated_user_id: Number(localStorage.getItem('user_id'))
                }
                dispatch(uploadWeareHouseData({ postData }))
                setFileList([]);
                setUploadModalVisible(true);
                setIsModalOpen(false)
                toast.success("Excel file uploaded successfully!");
                navigate(`/wearhouse`);

            }
        };

        reader.readAsArrayBuffer(file);
    };
    useEffect(() => {
        if (id) {
            try {
                const editId = window.atob(id)
                const assign_user_id = localStorage.getItem("user_id");

                if (assign_user_id) {
                    //   dispatch(prepQueueById({ editId, assign_user_id }));
                    // toast.success("Excel Prep Process Success");
                    setIsModalOpen(false);
                } else {
                    console.error("User ID not found in localStorage");
                }
            } catch (error) {
                console.error("Invalid base64 ID:", error);
            }
        }

        // if (addExcelPrepProcessError) {
        //   toast.error(addExcelPrepProcessErrorMessage || "An error occurred.");
        //   dispatch(resetSuccessFlag({ flag: "addExcelPrepProcessError" }));
        // }
    }, [dispatch, id, setIsModalOpen]);
    // const disabledData=preprocessingQueueData.filter((data)=>data.allocated==1)



    const columns = [
        {
            title: 'Unique ID',
            dataIndex: 'box_unique_id',
            key: 'box_unique_id',
            width: '25%',
        },

        {
            title: 'SPEC',
            dataIndex: 'spec',
            render: (text, record) => (record?.spec ? record?.spec : 'Yet to Assign'),
            key: 'spec',
            width: '30%',
        },
        {
            title: 'BOX',
            dataIndex: 'box',
            render: (text, record) => (record?.box >= 1 ? record?.box : '-'),
            key: 'box',
            width: '20%',
        },
        {
            title: 'ALT BOX',
            dataIndex: 'alt_box',
            render: (text, record) => (record?.alt_box >= 0 ? record?.alt_box : '-'),
            key: 'alt_box',
            width: '20%',
        },
        {
            title: 'Scantek Barcode',
            dataIndex: 'barcode',
            render: (text, record) => (record?.barcode ? record?.barcode : '-'),
            key: 'barcode',
            width: '40%',
        },
        {
            title: 'FROM',
            dataIndex: 'from',
            key: 'from',
            width: '40%',
            render: (text, record) => {
                // Enable editing for both tabs 1 and 2
                if (activetab === '1' || activetab === '2') {
                    return (
                        <Input
                            style={{ width: '200px' }}
                            value={record.from}
                            placeholder="Enter From"
                            onChange={(e) => {
                                const value = e.target.value;
                                let newData;
                                if (activetab === '1') {
                                    newData = [...preprocessingQueueData];
                                } else {
                                    newData = [...completedPreprocessingQueueData];
                                }

                                const index = newData.findIndex((item) => item.key === record.key);
                                if (index > -1) {
                                    newData[index] = { ...record, from: value };

                                    if (activetab === '1') {
                                        setPreprocessingQueueData(newData);
                                    } else {
                                        setCompletedPreprocessingQueueData(newData);
                                    }

                                    setModifiedRows((prev) => new Set(prev.add(record.key)));
                                }
                            }}
                        />
                    );
                } else {
                    return <span>{record.from}</span>;
                }
            }
        },

        {
            title: 'TO',
            dataIndex: 'to',
            key: 'to',
            width: '40%',
            render: (text, record) => {
                if (activetab === '1' || activetab === '2') {
                    return (
                        <Input
                            style={{ width: '200px' }}
                            value={record.to}
                            placeholder="Enter To"
                            onChange={(e) => {
                                const value = e.target.value;
                                const newData = [...preprocessingQueueData];
                                const index = newData.findIndex((item) => item.key === record.key);
                                if (index > -1) {
                                    newData[index] = { ...record, to: value };
                                    setPreprocessingQueueData(newData);
                                    setModifiedRows((prev) => new Set(prev.add(record.key)));
                                }
                            }}
                        />
                    );
                } else {
                    return <span>{record.to}</span>;
                }
            },
        },
        {
            title: 'LABEL PRINTED NAME/DATE',
            dataIndex: 'printed_name',
            key: 'printed_name',
            width: '80%',
            render: (text, record) => {
                if (activetab === '1' || activetab === '2') {
                    return (
                        <Input
                            style={{ width: '300px' }}
                            value={record.printed_name}
                            placeholder="Enter Printed Name"
                            onChange={(e) => {
                                const value = e.target.value;
                                const newData = [...preprocessingQueueData];
                                const index = newData.findIndex((item) => item.key === record.key);
                                if (index > -1) {
                                    newData[index] = { ...record, printed_name: value };
                                    setPreprocessingQueueData(newData);
                                    setModifiedRows((prev) => new Set(prev.add(record.key)));
                                }
                            }}
                        />
                    );
                } else {
                    return <span>{record.printed_name}</span>;
                }
            },
        },
        {
            title: 'DATE IN',
            dataIndex: 'date_in',
            key: 'date_in',
            render: (text, record) => {
                if (activetab === '1' || activetab === '2') {
                    return (
                        <DatePicker
                            format={"MM/DD/YYYY"}
                            style={{ width: '200px' }}
                            value={record.date_in ? dayjs(record.date_in) : null}
                            placeholder="Select Date In"
                            onChange={(date, dateString) => {
                                const newData = [...preprocessingQueueData];
                                const index = newData.findIndex((item) => item.key === record.key);
                                if (index > -1) {
                                    newData[index] = { ...record, date_in: dateString };
                                    setPreprocessingQueueData(newData);
                                    setModifiedRows((prev) => new Set(prev.add(record.key)));
                                }
                            }}
                        />
                    );
                } else {
                    return <span>{record.date_in ? moment(record.date_in).format("MM/DD/YYYY") : '-'}</span>;
                }
            },
            width: '40%',
        },
        {
            title: 'DESCRIPTION',
            dataIndex: 'description',
            key: 'description',
            render: (text, record) => {
                if (activetab === '1' || activetab === '2') {
                    return (
                        <TextArea
                            style={{ width: '300px' }}
                            value={record.description}
                            placeholder='Enter Description'
                            onChange={(e) => {
                                const value = e.target.value;
                                const newData = [...preprocessingQueueData];
                                const index = newData.findIndex((item) => item.key == record.key);
                                if (index > -1) {
                                    newData[index] = { ...record, description: value };
                                    setPreprocessingQueueData(newData);
                                    setModifiedRows(prev => new Set(prev.add(record.key)));
                                }
                            }}
                        />
                    );
                } else {
                    return <span>{record.description}</span>;
                }
            },
            width: '40%',
        },
        {
            title: 'Series Box',
            dataIndex: 'series_box',
            key: 'series_box',
            width: '40%',
            render: (text, record) => {
                if (activetab === '1' || activetab === '2') {
                    return (
                        <Input
                            style={{ width: '300px' }}
                            value={record.series_box}
                            placeholder='Enter Series Box'
                            onChange={(e) => {
                                const value = e.target.value;
                                const newData = [...preprocessingQueueData];
                                const index = newData.findIndex((item) => item.key == record.key);
                                if (index > -1) {
                                    newData[index] = { ...record, series_box: value };
                                    setPreprocessingQueueData(newData);
                                    setModifiedRows(prev => new Set(prev.add(record.key)));
                                }
                            }}
                        />
                    );
                } else {
                    return <span>{record.series_box}</span>;
                }
            },
        },
        {
            title: 'LOC',
            dataIndex: 'loc',
            key: 'loc',
            width: '60%',
            render: (text, record) => {
                if (activetab === '1' || activetab === '2') {
                    return (
                        <Input
                            style={{ width: '300px' }}
                            value={record.loc}
                            placeholder='Enter Loc'
                            onChange={(e) => {
                                const value = e.target.value;
                                const newData = [...preprocessingQueueData];
                                const index = newData.findIndex((item) => item.key == record.key);
                                if (index > -1) {
                                    newData[index] = { ...record, loc: value };
                                    setPreprocessingQueueData(newData);
                                    setModifiedRows(prev => new Set(prev.add(record.key)));
                                }
                            }}
                        />
                    );
                } else {
                    return <span>{record.loc}</span>;
                }
            },
        },
        {
            title: 'Buildindg or Address',
            dataIndex: 'building',
            key: 'building',
            width: '60%',
            render: (text, record) => {
                if (activetab === '1' || activetab === '2') {
                    return (
                        <Input style={{ width: '300px' }}
                            value={record.building}
                            placeholder='Enter Building'
                            // disabled={record.from}
                            onChange={(e) => {
                                const value = e.target.value;
                                const newData = [...preprocessingQueueData];
                                const index = newData.findIndex((item) => item.key == record.key);
                                if (index > -1) {
                                    newData[index] = { ...record, building: value };
                                    setPreprocessingQueueData(newData);
                                    setModifiedRows(prev => new Set(prev.add(record.key)));
                                }
                            }}
                        />
                    );
                } else {
                    return <span>{record.building}</span>;
                }
            }
        },
        {
            title: 'Aisle',
            dataIndex: 'aisle',
            key: 'aisle',
            width: '60%',
            render: (text, record) => {
                if (activetab === '1' || activetab === '2') {
                    return (
                        <Input style={{ width: '300px' }}
                            value={record.aisle}
                            placeholder='Enter Aisle'
                            // disabled={record.from}
                            onChange={(e) => {
                                const value = e.target.value;
                                const newData = [...preprocessingQueueData];
                                const index = newData.findIndex((item) => item.key == record.key);
                                if (index > -1) {
                                    newData[index] = { ...record, aisle: value };
                                    setPreprocessingQueueData(newData);
                                    setModifiedRows(prev => new Set(prev.add(record.key)));
                                }
                            }}
                        />
                    );
                } else {
                    return <span>{record.aisle}</span>;
                }
            },
        },
        {
            title: 'Level',
            dataIndex: 'level',
            key: 'level',
            width: '60%',
            render: (text, record) => {
                if (activetab === '1' || activetab === '2') {
                    return (
                        <Input style={{ width: '300px' }}
                            value={record.level}
                            placeholder='Enter Level'
                            // disabled={record.from}
                            onChange={(e) => {
                                const value = e.target.value;
                                const newData = [...preprocessingQueueData];
                                const index = newData.findIndex((item) => item.key == record.key);
                                if (index > -1) {
                                    newData[index] = { ...record, level: value };
                                    setPreprocessingQueueData(newData);
                                    setModifiedRows(prev => new Set(prev.add(record.key)));
                                }
                            }}
                        />
                    );
                } else {
                    return <span>{record.level}</span>;
                }
            },
        },
        {
            title: 'Shelf',
            dataIndex: 'shelf',
            key: 'shelf',
            width: '60%',
            render: (text, record) => {
                if (activetab === '1' || activetab === '2') {
                    return (
                        <Input style={{ width: '300px' }}
                            value={record.shelf}
                            placeholder='Enter Shelf'
                            // disabled={record.from}
                            onChange={(e) => {
                                const value = e.target.value;
                                const newData = [...preprocessingQueueData];
                                const index = newData.findIndex((item) => item.key == record.key);
                                if (index > -1) {
                                    newData[index] = { ...record, shelf: value };
                                    setPreprocessingQueueData(newData);
                                    setModifiedRows(prev => new Set(prev.add(record.key)));
                                }
                            }}
                        />
                    );
                } else {
                    return <span>{record.shelf}</span>;
                }
            },
        }
        ,
        // {
        //     title: 'Left Warehouse',
        //     dataIndex: 'left_warehouse',
        //     key: 'left_warehouse',
        //     width: '60%',
        //     render: (text, record) => (
        //         <Input style={{ width: '300px' }}
        //             value={record.left_warehouse}
        //             placeholder='Enter Building'
        //             // disabled={record.from}
        //             onChange={(e) => {
        //                 const value = e.target.value;
        //                 const newData = [...preprocessingQueueData];
        //                 const index = newData.findIndex((item) => item.key == record.key);
        //                 if (index > -1) {
        //                     newData[index] = { ...record, left_warehouse: value };
        //                     setPreprocessingQueueData(newData);
        //                     setModifiedRows(prev => new Set(prev.add(record.key)));
        //                 }
        //             }}
        //         />
        //     ),
        // }

        // {
        //   title: 'Building or Address',
        //   dataIndex: 'address',
        //   key: 'address',
        //   // width: '35%',
        //   render: (text, record) => (
        //     <Input style={{ width: '200px' }}
        //       value={record.address}
        //       placeholder='Enter Address'
        //       // disabled={record.customer_box_id}
        //       onChange={(e) => {
        //         const value = e.target.value;
        //         const newData = [...preprocessingQueueData];
        //         const index = newData.findIndex((item) => item.key == record.key);
        //         if (index > -1) {
        //           newData[index] = { ...record, address: value };
        //           setPreprocessingQueueData(newData);
        //           setModifiedRows(prev => new Set(prev.add(record.key)));
        //         }
        //       }}
        //     />
        //   ),
        // },
        // {
        //   title: 'Aisle',
        //   dataIndex: 'aisle',
        //   key: 'aisle',
        //   // width: '35%',
        //   render: (text, record) => (
        //     <Input style={{ width: '200px' }}
        //       value={record.aisle}
        //       placeholder='Enter Aisle'
        //       onChange={(e) => {
        //         const value = e.target.value;
        //         const newData = [...preprocessingQueueData];
        //         const index = newData.findIndex((item) => item.key == record.key);
        //         if (index > -1) {
        //           newData[index] = { ...record, aisle: value };
        //           setPreprocessingQueueData(newData);
        //           setModifiedRows(prev => new Set(prev.add(record.key)));
        //         }
        //       }}
        //     />
        //   ),
        // },
        // {
        //   title: 'Level',
        //   dataIndex: 'level',
        //   key: 'level',
        //   // width: '35%',
        //   render: (text, record) => (
        //     <Input style={{ width: '200px' }}
        //       value={record.level}
        //       placeholder='Enter Level'
        //       onChange={(e) => {
        //         const value = e.target.value;
        //         const newData = [...preprocessingQueueData];
        //         const index = newData.findIndex((item) => item.key == record.key);
        //         if (index > -1) {
        //           newData[index] = { ...record, level: value };
        //           setPreprocessingQueueData(newData);
        //           setModifiedRows(prev => new Set(prev.add(record.key)));
        //         }
        //       }}
        //     />
        //   ),
        // },
        // {
        //   title: 'Bay',
        //   dataIndex: 'bay',
        //   key: 'bay',
        //   // width: '35%',
        //   render: (text, record) => (
        //     <Input style={{ width: '200px' }}
        //       value={record.bay}
        //       placeholder='Enter Bay'
        //       onChange={(e) => {
        //         const value = e.target.value;
        //         const newData = [...preprocessingQueueData];
        //         const index = newData.findIndex((item) => item.key == record.key);
        //         if (index > -1) {
        //           newData[index] = { ...record, bay: value };
        //           setPreprocessingQueueData(newData);
        //           setModifiedRows(prev => new Set(prev.add(record.key)));
        //         }
        //       }}
        //     />
        //   ),
        // },
        // {
        //   title: 'From',
        //   dataIndex: 'from',
        //   key: 'from',
        //   // width: '35%',
        //   render: (text, record) => (
        //     <Input style={{ width: '200px' }}
        //       value={record.from}
        //       placeholder='Enter From'
        //       onChange={(e) => {
        //         const value = e.target.value;
        //         const newData = [...preprocessingQueueData];
        //         const index = newData.findIndex((item) => item.key == record.key);
        //         if (index > -1) {
        //           newData[index] = { ...record, from: value };
        //           setPreprocessingQueueData(newData);
        //           setModifiedRows(prev => new Set(prev.add(record.key)));
        //         }
        //       }}
        //     />
        //   ),
        // },
        // {
        //   title: 'Pickup Date',
        //   dataIndex: 'pickup_date',
        //   key: 'pickup_date',
        //   render: (text, record) => (
        //     <DatePicker
        //       format="MM/DD/YYYY"
        //       style={{ width: '200px' }}
        //       value={record.pickup_date ? dayjs(record.pickup_date) : null} // ensure moment object
        //       placeholder="Enter Pickup Date"
        //       onChange={(date) => {
        //         const newData = [...preprocessingQueueData];
        //         const index = newData.findIndex((item) => item.key === record.key);
        //         if (index > -1) {
        //           newData[index] = {
        //             ...record,
        //             pickup_date: date,
        //           };
        //           setPreprocessingQueueData(newData);
        //           setModifiedRows((prev) => new Set(prev.add(record.key)));
        //         }
        //       }}
        //     />
        //   ),
        // },
        // {
        //   title: 'Left Warehouse',
        //   dataIndex: 'left_warehouse',
        //   key: 'left_warehouse',
        //   render: (text, record) => (
        //     <DatePicker
        //       format="MM/DD/YYYY"
        //       style={{ width: '300px' }}
        //       value={record.left_warehouse ? dayjs(record.left_warehouse) : null} // ensure moment object
        //       placeholder="Enter Pickup Date"
        //       onChange={(date) => {
        //         const newData = [...preprocessingQueueData];
        //         const index = newData.findIndex((item) => item.key === record.key);
        //         if (index > -1) {
        //           newData[index] = {
        //             ...record,
        //             left_warehouse: date,
        //           };
        //           setPreprocessingQueueData(newData);
        //           setModifiedRows((prev) => new Set(prev.add(record.key)));
        //         }
        //       }}
        //     />
        //   ),
        // },
        // {
        //   title: 'Original Disposition',
        //   dataIndex: 'original_disposition',
        //   key: 'original_disposition',
        //   // width: '40%',
        //   render: (text, record) => (
        //     <Select
        //       style={{ width: '100%' }}
        //       options={original_dispositionData}
        //       value={record.original_disposition} // this should be the value
        //       placeholder="Select Original Disposition"
        //       onChange={(value,label) => {

        //         const selectedFile = original_dispositionData.find(item => item.value == value);
        //         if (!selectedFile) return;

        //         const updatedData = [...preprocessingQueueData];
        //         const index = updatedData.findIndex(item => item.key === record.key);

        //         if (index !== -1) {
        //           updatedData[index] = {
        //             ...updatedData[index],
        //             original_disposition: selectedFile.label, // store value only
        //           };
        //           setPreprocessingQueueData(updatedData);
        //           setModifiedRows(prev => new Set(prev).add(record.key));
        //         }
        //       }}
        //     />
        //   ),
        // },
        // {
        //   title: 'Disposition Days',
        //   dataIndex: 'disposition_day',
        //   key: 'disposition_day',
        //   // width: '35%',
        //   render: (text, record) => (
        //     <InputNumber style={{ width: '200px' }}
        //       value={record.disposition_day}
        //       placeholder='Enter Disposition Days'
        //       onChange={(value) => {
        //         const newData = [...preprocessingQueueData];
        //         const index = newData.findIndex((item) => item.key === record.key);
        //         if (index > -1) {
        //           newData[index] = { ...record, disposition_day: value };
        //           setPreprocessingQueueData(newData);
        //           setModifiedRows(prev => new Set(prev.add(record.key)));
        //         }
        //       }}
        //     />
        //   ),
        // },


    ];
    const getAllBarocde = preprocessingQueueData.filter((data) => data.barcode != null).map((item) => ({
        value: item.barcode,
        label: item.barcode,
    }))
    const getAllUniqueID = preprocessingQueueData.filter((data) => data.barcode != null).map((item) => ({
        value: item.box_unique_id,
        label: item.box_unique_id,
    }))
    const onSelectChange = (newSelectedRowKeys, newRow) => {
        setSelectedRowKeys(newRow);
    };
    const rowSelection = {
        onChange: onSelectChange,

        getCheckboxProps: record => ({
            disabled: record.spec == null, // Example: disable row based on data
        }),
    };
    const handleSaveData = (_, actionType) => {
        let currentData, originalDataRef;
        const isPagination = actionType === "pagination";
        // Determine which data to use based on active tab
        if (activetab === '1') {
            currentData = preprocessingQueueData;
            originalDataRef = originalData;
        } else if (activetab === '2') {
            currentData = completedPreprocessingQueueData;
            originalDataRef = completedOrginalData;
        } else {
            toast.error("Invalid tab selection!");
            return;
        }
        if (originalDataRef.length === 0 || !currentData.length) {
            toast.error("No data to save!");
            return;
        }

        const parsedOriginalData = JSON.parse(originalDataRef);
        const updatedData = currentData.filter((item) => {
            const originalItem = parsedOriginalData.find((orig) => orig.key === item.key);
            return originalItem && JSON.stringify(originalItem) !== JSON.stringify(item);
        });
        if (updatedData.length === 0) {
            if (!isPagination) toast.info("No changes detected.");
            return;
        }

        const modifiedData = updatedData.filter((item) => modifiedRows.has(item.key));

        if (modifiedData.length === 0) {
            toast.info("No modified rows to save.");
            return;
        }

        const postData = {
            updatedData: modifiedData,
            customer_id: currentData[0]?.customer_id,
            assign_user_id: userId,
            prep_queue_id: atob(id),
            activetab: activetab,
            updated_user_id: Number(localStorage.getItem('user_id'))
        };

        dispatch(updateWeareHouseData({ postData }))
            .unwrap()
            .then(() => {
                // On successful save, re-fetch the updated data for the current tab
                const editId = atob(id);
                const assign_user_id = localStorage.getItem('user_id');

                if (activetab === '1') {
                    dispatch(weareHouseById({ editId, assign_user_id }))
                        .then(() => {
                            toast.success("Data saved successfully!");
                            setModifiedRows(new Set());
                        });
                } else if (activetab === '2') {
                    dispatch(completedweareHouseById({ editId, assign_user_id }))
                        .then(() => {
                            toast.success("Data saved successfully!");
                            setModifiedRows(new Set());
                        });
                }
            })
            .catch((error) => {
                console.error("Save error:", error);
                toast.error(error.message || "Error saving data. Please check if Spec ID is selected.");
            });
    };
    const handleFilterChange = (payload = {}) => {
        const editId = window.atob(id);
        dispatch(weareHouseById({ editId, uniqueIdStartValue, uniqueIdEndValue, barocdestartvalue, barocdeendvalue, ...payload }));
        setSearchModal(false);
        setBarocdestartvalue(null);
        setBarocdeendvalue(null);
        setUniqueIdStartValue(null);
        setUniqueIdEndValue(null);


    };
    const clearFilterData = () => {
        setClearData(false);
        setBarocdestartvalue(null);
        setBarocdeendvalue(null);
        setUniqueIdStartValue(null);
        setUniqueIdEndValue(null);

    }
    return (
        <>
            {/* <Loader loading={prepTeamQueueLoading} /> */}
            <PageHeader
                HeaderText="Export Barocde /WareHouse"
                Breadcrumb={[{ name: "Export Barocde /WareHouse" }]}
                backButtonUrl="/wearhouse"
            />
            <Tabs activeKey={activetab} defaultActiveKey="1" onChange={(key) => setActiveTab(key)} type="card"
                tabBarExtraContent={
                    <Flex align="center" style={{ gap: "10px", flexWrap: "wrap" }}>
                        <Button
                            style={{ backgroundColor: '#1e90a9' }}
                            shape="round"
                            type="primary"
                            icon={<PrinterOutlined />}
                            onClick={handleDownloadUniqueIDLabel}
                        >
                            Export Unique ID Label
                        </Button>

                        <Button
                            style={{ backgroundColor: '#1e90a9' }}
                            shape="round"
                            type="primary"
                            icon={<ScanOutlined />}
                            onClick={handleDownloadBarcodeExcel}
                        >
                            Export Scantek Barcode
                        </Button>


                        <Button
                            style={{ backgroundColor: "green", color: "white" }}
                            shape="round"
                            type="default"
                            icon={<SaveOutlined />}
                            onClick={handleSaveData}
                        >
                            Save
                        </Button>


                    </Flex>
                }>
                <TabPane tab="In Progress Boxes" key="1">
                    <Card>
                        {/* Controls row */}
                        <Flex align="center" style={{ gap: "10px", flexWrap: "wrap", marginBottom: "10px" }}>
                            <SearchComponent
                                style={{ width: "400px" }}
                                placeHolder="Search Unique ID or Spec or Barcode"
                                onChange={(e) => getData({ query: e.target.value })}
                            />
                            <Button
                                style={{ backgroundColor: '#249245ff' }}
                                shape="round"
                                type="primary"
                                onClick={() => setSearchModal(true)}
                            >
                                Search By Range Filters
                            </Button>
                            <Button
                                style={{ backgroundColor: '#da7e22ff' }}
                                shape="round"
                                type="primary"
                                icon={<DownloadOutlined />}
                                onClick={handleDownloadExcel}
                            >
                                Download Template
                            </Button>
                            <Button
                                style={{ backgroundColor: '#7e0e0eff' }}
                                shape="round"
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={showModal}
                            >
                                Upload Excel
                            </Button>




                            {clearData && (
                                <Button
                                    className="btn-danger"
                                    shape="round"
                                    icon={<ReloadOutlined />}
                                    onClick={clearFilterData}
                                >
                                    Clear Filters
                                </Button>
                            )}
                        </Flex>


                        <Modal
                            open={searchModal}
                            onCancel={() => {
                                setSearchModal(false);
                                setBarocdestartvalue(null);
                                setBarocdeendvalue(null);
                                setUniqueIdStartValue(null);
                                setUniqueIdEndValue(null);
                            }}
                            onOk={handleFilterChange}
                            okText="Search"
                            title={
                                <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                                    <SearchOutlined style={{ marginRight: 6 }} />
                                    Search Range Filter
                                </span>
                            }
                            width={650}
                        >
                            {/* Barcode Section */}
                            <span style={{ fontWeight: "bold", fontSize: "16px" }}>Barcode FIlter</span>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <label style={{ marginBottom: "6px", fontWeight: "500", display: "block" }}>
                                        Start Value
                                    </label>
                                    <Select
                                        showSearch
                                        options={getAllBarocde}
                                        placeholder="Enter Barcode Start Value"
                                        value={barocdestartvalue}
                                        onChange={(value) => setBarocdestartvalue(value)}
                                        style={{ width: "100%" }}
                                    />
                                </Col>
                                <Col span={12}>
                                    <label style={{ marginBottom: "6px", fontWeight: "500", display: "block" }}>
                                        End Value
                                    </label>
                                    <Select
                                        showSearch
                                        options={getAllBarocde}
                                        placeholder="Enter Barcode End Value"
                                        value={barocdeendvalue}
                                        onChange={(value) => setBarocdeendvalue(value)}
                                        style={{ width: "100%" }}
                                    />
                                </Col>
                            </Row>
                            {/* Unique ID Section */}
                            <div style={{ fontWeight: "bold", fontSize: "16px", marginTop: '20px' }}>Unique ID FIlter</div>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <label style={{ marginBottom: "6px", fontWeight: "500", display: "block" }}>
                                        Start Value
                                    </label>
                                    <Select
                                        showSearch
                                        options={getAllUniqueID}
                                        placeholder="Enter Unique ID Start Value"
                                        value={uniqueIdStartValue}
                                        onChange={(value) => setUniqueIdStartValue(value)}
                                        style={{ width: "100%" }}
                                    />
                                </Col>
                                <Col span={12}>
                                    <label style={{ marginBottom: "6px", fontWeight: "500", display: "block" }}>
                                        End Value
                                    </label>
                                    <Select
                                        showSearch
                                        options={getAllUniqueID}
                                        placeholder="Enter Unique ID End Value"
                                        value={uniqueIdEndValue}
                                        onChange={(value) => setUniqueIdEndValue(value)}
                                        style={{ width: "100%" }}
                                    />
                                </Col>
                            </Row>
                        </Modal>
                        {/* Table or other content below */}
                    </Card>


                    <Form form={form} component={false}>
                        <TableComponent
                            rowSelection={rowSelection}
                            dataSource={activetab == '1' ? preprocessingQueueData : completedPreprocessingQueueData}
                            columns={columns}
                            onChangeDispatch={(payload) => {
                                getData(payload);
                                handleSaveData(payload, "pagination");
                            }}
                        />

                    </Form>
                </TabPane>
                <TabPane tab="Barcode Printed Boxes" key="2">
                    <Space size={"middle"} className="my-3">

                        <SearchComponent
                            placeHolder="Search Unique ID or Spec or Scantek Barcode"
                            style={{ width: "500px" }}
                            onChange={e => {
                                const payloadData = {
                                    query: e.target.value,
                                };
                                getData(payloadData);
                            }} />


                    </Space>

                    <Form form={form} component={false}>
                        <TableComponent
                            rowSelection={rowSelection}
                            dataSource={activetab == '1' ? preprocessingQueueData : completedPreprocessingQueueData}
                            columns={columns}
                            onChangeDispatch={(payload) => {
                                getData(payload);
                                handleSaveData(payload);
                            }}
                        />

                    </Form>
                </TabPane>
            </Tabs>

            <Modal title="Upload Excel File" open={isModalOpen} onOk={handleUpload} onCancel={handleCancel} okText="Upload">
                <Upload
                    beforeUpload={(file) => {
                        setFileList([file]);
                        return false;
                    }}
                    fileList={fileList}
                    accept=".xlsx, .xls"
                >
                    <Button icon={<UploadOutlined />}>Select Excel File</Button>
                </Upload>
            </Modal>
            {/* {prepTeamQueueLoading ? <Loader /> : <>
        <Modal
          title="Upload in Progress"
          open={uploadModalVisible}
          footer={[
            <Button key="logs" type="primary" className='primary-btn' onClick={() => navigate("/upload-log")}>
              Go to Upload Logs
            </Button>,
          ]}
          onCancel={() => setUploadModalVisible(false)}
        >
          <p>Data upload is in progress. Please check upload logs.</p>
        </Modal>
      </>} */}
        </>
    );
};

export default AddWareHouse;